module.exports = __webpack_public_path__ + "img/fu0006.bb4ee4e5.webp";